import moment from 'moment';

export const formatDateToPeriods = (date) => {
  return moment(date).format('YYYYMMDD');
};

export const formatDate = (date) => {
  return moment(date).format('YYYY-MM-DD');
};
